'use client'

import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import StaticExploreFeed from '../StaticExploreFeed'
import ChatCard from '../ChatCard'
import { landingBrowseContent } from './landingBrowseContent'
import { landingExploreFeed } from './landingMotionContent'
import styles from './LandingBrowseGallery.module.css'

const exploreCards = landingExploreFeed.filter(
  ({ nsfw, blurred }) => !nsfw && !blurred,
)

const cardImageSizes =
  '(max-width: 700px) calc((100vw - 48px) / 2), (max-width: 767px) calc((100vw - 80px) / 2), (max-width: 1023px) calc((100vw - 88px) / 3), (max-width: 1100px) calc((100vw - 96px) / 4), (max-width: 1275px) calc((100vw - 120px) / 4), (max-width: 1439px) 289px, 230px'
const featuredImageSizes =
  '(max-width: 599px) calc(100vw - 40px), (max-width: 700px) calc((100vw - 48px) / 2), (max-width: 1023px) calc((100vw - 80px) / 2), (max-width: 1100px) calc((100vw - 88px) / 3), (max-width: 1275px) calc((100vw - 112px) / 3), 388px'

function Arrow() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5 12h14m-6-6 6 6-6 6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function LandingBrowseGallery({
  focus = 'create',
  exploreFeed,
  featuredGrid = false,
}) {
  const { t } = useTranslation()
  const chatFirst = focus === 'chat'
  const content = landingBrowseContent[chatFirst ? 'chat' : 'create']
  const headingId = `landing-browse-${chatFirst ? 'chat' : 'create'}`
  const images = (exploreFeed ?? exploreCards)
    .filter(({ nsfw, blurred }) => !nsfw && !blurred)
    .map(({ translationPrefix = 'landingV2_card_', ...card }) => ({
      ...card,
      title: t(`${translationPrefix}${card.id}_title`, {
        defaultValue: card.title,
      }),
      description: t(`${translationPrefix}${card.id}_description`, {
        defaultValue: card.description,
      }),
      style: t(`landingV2_style_${card.style.toLowerCase()}`),
    }))

  return (
    <section
      className={styles.browse}
      aria-labelledby={headingId}
      data-landing-section="browse"
    >
      <div className={styles.inner}>
        <div className={styles.heading}>
          <div>
            <h2 id={headingId}>{t(content.title)}</h2>
            <p>{t(content.description)}</p>
          </div>
          <Link
            href={content.href}
            prefetch={false}
            className={styles.browseAll}
            data-landing-action={chatFirst ? 'discover' : 'explore'}
          >
            {t(content.action)}
            <Arrow />
          </Link>
        </div>
        {chatFirst ? (
          <ul className={styles.discoverGrid}>
            {content.cards.map((card, index) => (
              <li
                key={card.id}
                className={styles.feedCard}
                data-landing-action="character_card"
                data-landing-item={String(index + 1)}
              >
                <ChatCard
                  signupOnly
                  explore
                  id={card.id}
                  imageUrl={[card.src]}
                  video={card.video}
                  imageAlt={t(`landingV2_card_${card.translationId}_title`)}
                  name={card.name}
                  age={card.age}
                  scenario={t(card.scenarioKey)}
                />
              </li>
            ))}
          </ul>
        ) : (
          <StaticExploreFeed
            images={images}
            signupOnly
            trackActions
            featuredGrid={featuredGrid}
            imageSizes={featuredGrid ? featuredImageSizes : cardImageSizes}
          />
        )}
      </div>
    </section>
  )
}
